export default __webpack_public_path__ + "static/media/icon_awesome_twitter.2f9c6e5a.png";